import * as _ from 'lodash';

import { SurveyAggregateQuestionValue } from './surveyAggregateQuestionValue';

export class SurveyAggregateQuestion {
  public name: string;
  public description: string;
  public enumerated: boolean;
  public responses: Array<SurveyAggregateQuestionValue> = new Array<SurveyAggregateQuestionValue>();

  public get hasNoResponses(): boolean {
    return _.isEmpty(this.responses);
  }

  static parse(data: any): SurveyAggregateQuestion {
    let question = new SurveyAggregateQuestion();
    question.description = data.description;
    question.enumerated = data.enumerated;
    question.name = data.name;
    question.responses = _.chain(data.responses)
      .map((r) => SurveyAggregateQuestionValue.parse(r))
      .orderBy((r) => r.rank)
      .value();
    return question;
  }
}
